import { MenuItem, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from 'yup';
import WushTextField from "../WushTextField";
import update from "../../../api/auth/reservations/reservationQuestions/reservationAnswers/update";
import create from "../../../api/auth/reservations/reservationQuestions/reservationAnswers/create";
import useYupValidationResolver from "../../../services/useYupValidationResolver";

export default function ReservationAnswer({ reservation, question }) {
  const answerValidation = question.required ? yup.string().required("Required") : yup.string();

  const validationSchema = yup.object({
    answer: answerValidation
  });

  const { register, handleSubmit, formState } = useForm({
    resolver: useYupValidationResolver(validationSchema),
  });

  const onSubmit = (values) => {
    if(question.answer) {
      update(reservation.id, question.id, question.answer.id, values, (response) => {
        console.log(response);
      });
    } else {
      create(reservation.id, question.id, values, (response) => {
        console.log(response);
      });
    }
  };

  const formRegistration = (onChange = false) => {
    return register('answer', { onBlur: handleSubmit(onSubmit), onChange: onChange && handleSubmit(onSubmit)});
  };

  const renderInput = () => {
    if(question.answer_data_type === 'text') {
      return (
        <WushTextField formRegistration={formRegistration()} formState={formState} label="Answer" defaultValue={question.answer?.answer} />
      );
    } else if(question.answer_data_type === 'number') {
      return (
        <WushTextField formRegistration={formRegistration()} formState={formState} label="Answer" type="number" defaultValue={question.answer?.answer}/>
      );
    } else if(question.answer_data_type === 'date') {
      return (
        <WushTextField formRegistration={formRegistration()} formState={formState} label="Answer" type="date" defaultValue={question.answer?.answer}/>
      );
    } else if(question.answer_data_type === 'boolean') {
      return (
        <WushTextField formRegistration={formRegistration(true)} label="Answer" select defaultValue={["t", "true", true].includes(question.answer?.answer)}>
          <MenuItem value={true}>Yes</MenuItem>
          <MenuItem value={false}>No</MenuItem>
        </WushTextField>
      );
    }
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        {renderInput()}
      </form>
    </Stack>
  );
}